// ** Amplify
import { API } from "aws-amplify"
// **  store names
import { STORES } from "@constants/redux"

// ** main app Logger
import { appLogger } from "@helpers/logger"

import { userRoles } from "@constants/system"
// ** constants
import { globalConst } from "@constants/global"

// **  utility
import { isEmpty, drop } from "lodash"

/** users groups */
const GROUP = globalConst.auth.groups

// ** fuzzy search support
import Fuse from "fuse.js"
import { devLog } from "@helpers/devLog"

const LOCAL_COMPANIES_STORAGE_KEY = "admin_local_companies_v1"

const readLocalCompanies = () => {
  if (typeof window === "undefined") return []
  try {
    const raw = window.localStorage.getItem(LOCAL_COMPANIES_STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed : []
  } catch (_error) {
    return []
  }
}

const writeLocalCompanies = (items) => {
  if (typeof window === "undefined") return
  window.localStorage.setItem(
    LOCAL_COMPANIES_STORAGE_KEY,
    JSON.stringify(Array.isArray(items) ? items : [])
  )
}

/** initla state for auth store  */
const initialState = {
  data: [],
  current: {},
  perPageValues: [5, 10, 25, 50],
  itemPerPage: 5,
  filters: {
    status: {
      label: "label_all",
      value: "ALL"
    }
  },
  error: null,
  keyword: null,
  message: null,
  action: globalConst.action.NONE
}

export const companies = {
  state: initialState,

  reducers: {
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setData: (s, payload) => {
      return {
        ...s,
        data: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    pushNewData: (s, payload) => {
      return {
        ...s,
        data: [...s.data, payload]
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setError: (s, payload) => {
      return {
        ...s,
        error: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setMessage: (s, payload) => {
      return {
        ...s,
        message: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setFilters: (s, payload) => {
      return {
        ...s,
        filters: { ...s.filters, ...payload }
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setKeyword: (s, payload) => {
      return {
        ...s,
        keyword: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setitemPerPage: (s, payload) => {
      return {
        ...s,
        itemPerPage: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCurrent: (s, payload) => {
      return {
        ...s,
        current: payload
      }
    },

    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setAction: (s, payload) => {
      return {
        ...s,
        action: payload
      }
    }
  },
  selectors: (slice, createSelector) => ({
    /**
     *
     * @returns
     */
    error() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.companies],
        (companies, stuffsLoading) => {
          return stuffsLoading.error || ""
        }
      )
    },

    /**
     * success selector used in different
     * auth actions
     *
     * @returns {String}
     */
    success() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.companies],
        (companies, companiesLoading) => companiesLoading.success
      )
    },
    paginationData() {
      return createSelector([slice], (companies) => {
        let _data = companies.data
        if (!isEmpty(companies.filters)) {
          const status = companies.filters.status

          _data = !!status
            ? status.value !== "ALL"
              ? companies.data.filter((e) => e.status === status.value)
              : companies.data
            : companies.data
          const offset = (companies.currentPage - 1) * companies.itemPerPage
          _data = drop(_data, offset).slice(0, companies.itemPerPage)
        }
        if (!!companies.keyword) {
          const options = {
            keys: ["name", "email", "location"]
          }
          const fuse = new Fuse(companies.data, options)
          let data = fuse.search(companies.keyword)
          data = data.map((e) => e.item)
          const offset = (companies.currentPage - 1) * companies.itemPerPage
          _data = drop(data, offset).slice(0, companies.itemPerPage)
        }
        if (companies.data.length) {
          const offset = (companies.currentPage - 1) * companies.itemPerPage
          _data = drop(_data, offset).slice(0, companies.itemPerPage)
        }
        return _data
      })
    }
  }),
  effects: (dispatch) => ({
    /**
     *
     */
    async fetchCompanies() {
      appLogger.info("fetchCompanies", `[REDUX][${STORES.COMPANIES}]`)
      this.setAction(globalConst.action.FETCH_COMAPNIES)
      try {
        if (false) {
          this.setData(readLocalCompanies())
          this.setAction(globalConst.action.NONE)
          return
        }
        const result = await API.get("providersApiGateway", "/providers")

        this.setData(result)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setData([])
        this.setAction(globalConst.action.NONE)
      }
    },
    /**
     *
     * @param {*} payload
     */
    async saveNewCompany(payload) {
    
      appLogger.info("saveNewCompany", `[REDUX][${STORES.COMPANIES}]`)
      this.setAction(globalConst.action.ADD_NEW_COMAPNIES)
      try {
        if (false) {
          const localCompany = {
            ...payload,
            pk: `local-company-${Date.now()}`,
            status: payload.status || "ACTIVE"
          }
          const next = [...readLocalCompanies(), localCompany]
          writeLocalCompanies(next)
          this.pushNewData(localCompany)
          this.setMessage("msg_company_added_sucess")
          this.setAction(globalConst.action.NONE)
          return localCompany
        }
        const result = await API.post("providersApiGateway", "/providers", {
          body: payload
        })
        const provider = {
          ...payload,
          status: result.status || "ACTIVE",
          pk: result.id || result.pk
        }
        this.pushNewData(provider)
        this.setMessage("msg_company_added_sucess")
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        const _error = error.message || error.response
        this.setError(_error)
        this.setAction(globalConst.action.NONE)
        return
      }
    },

    /**
     *
     * @param {*} id
     */
    async activateCompany(id) {
     
      appLogger.info("activateCompany", `[REDUX][${STORES.COMPANIES}]`)
      this.setAction(globalConst.action.ACTIVATE_COMAPNIES)
      try {
        if (false) {
          const next = readLocalCompanies().map((item) =>
            item.pk === id ? { ...item, status: "ACTIVE" } : item
          )
          writeLocalCompanies(next)
          this.setData(next)
          this.setAction(globalConst.action.NONE)
          return
        }
        const result = await API.put("providersApiGateway", `/providers/${id}`)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        const _error = error.message || error.response
        this.setError(_error)
        this.setAction(globalConst.action.NONE)
        return
      }
    },
    /**
     *
     * @param {*} id
     */
    async disableCompany(id) {
     
      appLogger.info("disableCompany", `[REDUX][${STORES.COMPANIES}]`)
      this.setAction(globalConst.action.DISABLE_COMAPNIES)
      try {
        if (false) {
          const next = readLocalCompanies().map((item) =>
            item.pk === id ? { ...item, status: "INACTIVE" } : item
          )
          writeLocalCompanies(next)
          this.setData(next)
          this.setMessage("msg_company_disabled")
          this.setAction(globalConst.action.NONE)
          return
        }
        const result = await API.del(
          "providersApiGateway",
          `/providers/${id}/status`
        )
        this.setMessage("msg_company_disabled")
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        const _error = error.message || error.response
        this.setError(_error)
        this.setAction(globalConst.action.NONE)
        return
      }
    },
    /**
     *
     * @param {*} id
     */
    async enableCompany(id) {
 
      appLogger.info("enableCompany", `[REDUX][${STORES.COMPANIES}]`)
      this.setAction(globalConst.action.ENABLE_COMAPNIES)
      try {
        if (false) {
          const next = readLocalCompanies().map((item) =>
            item.pk === id ? { ...item, status: "ACTIVE" } : item
          )
          writeLocalCompanies(next)
          this.setData(next)
          this.setMessage("msg_company_enabled")
          this.setAction(globalConst.action.NONE)
          return
        }
        const result = await API.put(
          "providersApiGateway",
          `/providers/${id}/status`
        )
        this.setMessage("msg_company_enabled")
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        const _error = error.message || error.response
        this.setError(_error)
        this.setAction(globalConst.action.NONE)
        return
      }
    },
    /**
     * Get stuff by PK
     *
     * @param {*} id
     */
    // async getStuff(id) {
    //   appLogger.info("getStuff", `[REDUX][${STORES.STUFFS}]`)
    //   this.setAction(globalConst.action.GET_STUFF)
    //   try {
    //     devLog(id)
    //     const result = await API.get("stuffsApiGateway", `/stuffs/${id}`)
    //     this.setCurrent(result)
    //     this.setAction(globalConst.action.NONE)
    //   } catch (error) {
    //     devLog(error.response)
    //   }
    // }
    /**
     *
     * @param {*} param0
     */
    resetCurrentRecord(data) {
      this.setCurrent(data)
    },
    /**
     *
     * @param {*} payload
     */
    onItemPerPageChange(payload) {
      this.setitemPerPage(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onFiltersChange(payload) {
      this.setFilters(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onKeywordChange(payload) {
      this.setKeyword(payload)
    },
    /**
     *
     */
    onAcionReset() {
      this.setAction(globalConst.action.NONE)
    }
  })
}
